{
    "longSHA": "3195314892aaf8330b8543868dfff280667ae2ec",
    "shortSHA": "3195314",
    "branch": "development",
    "authorName": "Damjan Tonkli",
    "commitTime": "Fri Dec 12 16:31:02 2025 +0100",
    "commitMsg": "fix(offer): additional charge price mapping & models",
    "totalCommitCount": "1"
}